import { useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { analyticsLogUserClickedOnNotification } from "features/notifications/analytics";

import isSupportedAnalyticsSource from "../../../../features/notifications/analytics/isSupportedAnalyticsSource";
import { NotificationStateKeys } from "../consts";
import { getAnalyticsDataFromQueryParams } from "./getAnalyticsDataFromQueryParams";

export default function useAnalytics() {
  const { source, notificationType } = useGetNotificationSource();

  useEffect(() => {
    if (isSupportedAnalyticsSource(source) && notificationType) {
      analyticsLogUserClickedOnNotification(source!, notificationType);
    }
  }, [source, notificationType]);
}

function useGetNotificationSource() {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const { sourceKey, source, notificationType } =
    getAnalyticsDataFromQueryParams(searchParams);

  const clearURLParams = () => {
    searchParams.delete(sourceKey!);
    history.replace(`${pathname}?${searchParams}`, {
      ...history.location.state,
      [NotificationStateKeys.SOURCE]: source,
      [NotificationStateKeys.TYPE]: notificationType
    });
  };

  if (sourceKey && source && notificationType) {
    clearURLParams();
  }

  return { source, notificationType };
}
